const custom_profile_fields = {
    /** UNTRANSLATED */
    entity_not_exists_with_names: 'Cannot find entities with the given names: {{names}}',
    invalid_min_max_input: '最小値と最大値の入力が無効です。',
    invalid_options: 'フィールドオプションが無効です。',
    invalid_regex_format: '正規表現の形式が無効です。',
    invalid_address_parts: '住所の構成要素が無効です。',
    invalid_fullname_parts: '氏名の構成要素が無効です。',
    name_exists: '指定された名前のフィールドはすでに存在します。',
    conflicted_sie_order: 'サインイン体験のフィールド順序の値が重複しています。',
    /** UNTRANSLATED */
    invalid_name: 'Invalid field name, only letters or numbers are allowed, case sensitive.',
};
export default Object.freeze(custom_profile_fields);
